import {useDispatch, useSelector} from "react-redux";
import {clearEventContent, getEventData, setEventValue} from "../../store/reducers/events/events.reducer";
import React, {useRef, useState} from "react";
import SiteBreadCrumb from "../../components/page-breadcrumb/page-breadcrumb.component";
import Typography from "@mui/material/Typography";
import SingleImageUpload from "../../components/input/single-image-upload.component";
import TextInputField from "../../components/input/text-input-field.component";
import DateInputField from "../../components/input/date-input-field.component";
import {useNavigate} from "react-router-dom";
import {Editor} from "@tinymce/tinymce-react";
import ActionButton from "../../components/button/button.component";
import AdvancedFileManager from "../../components/input/advanced-file-manager.component";
import sendApiRequest, {NetworkMethods} from "../../lib/Network";
import {getTinymce} from "@tinymce/tinymce-react/lib/es2015/main/ts/TinyMCE";
import toast from "react-hot-toast";
import {getCurrentUser} from "../../store/reducers/user/user.reducer";
import TextSelectDropdownField from "../../components/input/text-select-dropdown-field.component";

const handleImageItemClick = (url: string) => {
    let currentContent = getTinymce(window)?.activeEditor?.getContent() + "";
    currentContent += `<img src="${url}" alt="kep" width="300" height="300" style="object-fit: scale-down" />`
    getTinymce(window)?.activeEditor?.setContent(currentContent);
}

const defaultPlaces = [
    {
        title: 'Kőszegszerdahely',
        value: 'Kőszegszerdahely',
    },
    {
        title: 'Bozsok',
        value: 'Bozsok',
    },
    {
        title: 'Velem',
        value: 'Velem',
    },
    {
        title: 'Kőszegdoroszló',
        value: 'Kőszegdoroszló',
    },
    {
        title: 'Szombathely',
        value: 'Szombathely',
    },
]

export default function EventCreate()
{
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const editorRef: any = useRef("");

    const [isLoading, setIsLoading] = useState<boolean>();
    const [isOpenMediaManager, setIsOpenMediaManager] = useState<boolean>(false);

    const currentUser = useSelector(getCurrentUser);
    const eventData = useSelector(getEventData);

    const { id, date, place, preview,
    permament, title, slugTitle, content} = eventData;

    const handlePreviewChange = (url: string) => dispatch(setEventValue("preview", url));
    const handleTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => dispatch(setEventValue("title", event.target.value));
    const handleDateChange = (datestring: string) => dispatch(setEventValue("date", datestring));
    const onPlaceChange = (e: React.ChangeEvent<HTMLInputElement>) => dispatch(setEventValue("place", e.target.value));

    const onSubmit = async () => {
        try {
            const response = await sendApiRequest({
                headers: {
                    "x-public-key": process.env.REACT_APP_PUBLIC_REQUEST_KEY,
                    'Authorization': 'Bearer ' + currentUser.token
                },
                method: NetworkMethods.POST,
                endpoint: `event/create`,
                payload: {
                    ...eventData,
                    content: getTinymce(window)?.activeEditor?.getContent() + ""
                }
            });

            if (!response.isSuccess) {
                toast.error(`Hiba a létrehozás közben! Indok: ${response?.error ?? "Nincs indok!"}`)
                return
            }

            toast.success("Sikeres létrehozás!");
            dispatch(clearEventContent());
            getTinymce(window)?.activeEditor?.setContent("");
        } catch (error: any) {
            toast.error(`Hiba a létrehozás közben! Indok: ${error?.message ?? "Nincs indok!"}`)
        }
    }

    if (isLoading)
    {
        return <div>Betöltés...</div>
    }

    return <div>
        <SiteBreadCrumb sites={[
            {
                name: "Főoldal",
                url: "/"
            },
            {
                name: "Események",
                url: "/esemenyek"
            },
            {
                name: "Létrehozás",
                url: "/letrehozas"
            },
        ]}/>
        <Typography variant='h3'>Esemény varázsló</Typography>
        <br/>
        <br/>
        <Typography variant='h3'>Előkép szerkesztés</Typography>
        <br/>
        <SingleImageUpload value={preview} onChange={handlePreviewChange}/>
        <br/>
        <TextInputField title={"Bejegyzés címe"} value={title} onChange={handleTitleChange} fullWidth/>
        <DateInputField title={"Dátum"} value={new Date(date)} onChange={handleDateChange}/>
        <TextSelectDropdownField value={place} onChange={onPlaceChange} data={defaultPlaces}
                                 title={'Helyszín'} />
        <br/>
        <Typography variant='h3'>Tartalom megadása</Typography>
        <br/>
        <Editor
            apiKey='q6aeudc76f8tjyl69ll8d2i4wsw4sasm6yhd4fhvl7ko47ph'
            onInit={(_evt, editor) => editorRef.current = editor}
            initialValue={content}
            init={{
                height: 1300,
                menubar: false,
                language: 'hu_HU',
                plugins: [
                    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                    'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                ],
                toolbar: 'undo redo | blocks | ' +
                    'bold italic forecolor | alignleft aligncenter ' +
                    'alignright alignjustify | bullist numlist outdent indent | ' +
                    'removeformat | shortcuts',
                a11y_advanced_options: true,
                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                setup: function (editor) {
                    editor.ui.registry.addMenuButton('shortcuts', {
                        tooltip: 'shortcuts',
                        icon: 'browse',

                        fetch: function (callback: any) {
                            const items = [
                                {
                                    type: 'menuitem',
                                    text: 'Fájl feltöltése',
                                    onAction: function () {
                                        setIsOpenMediaManager(!isOpenMediaManager);
                                    }
                                },
                            ];
                            callback(items);
                        }
                    });
                }
            }}
        />

        <br/>
        <br/>
        <ActionButton title="Esemény létrehozása" type={"SAVE"} action={onSubmit}/>

        <AdvancedFileManager
            isOpen={isOpenMediaManager}
            handleClose={() => setIsOpenMediaManager(!isOpenMediaManager)}
            handleAudioFileSelection={() => {
            }}
            handleImageFileSelection={handleImageItemClick}
        />
    </div>
}